import appRequest from '@apis/app'
import learnRequest from '@apis/learn'
import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  HStack,
  Icon,
  Image,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {ReactComponent as MicIcon} from '@assets/svgs/mic_2.svg'
import {Modal} from 'antd'
import Volume from '@assets/svgs/volume.svg'
import GlobalMic3 from '@components/GlobalMic3'
import headphoneIcon from '@assets/svgs/learn/headphone.svg'

const UserMsg = ({msg}: {msg: any}) => {
  const {audioFileUser} = useSelector((state: any) => state.learnPartThree)
  const [speechCheckData, setSpeechCheckData] = useState<any>()
  const [speechCheckDataBest, setSpeechCheckDataBest] = useState<any>()
  const [speechCheckDataList, setSpeechCheckDataList] = useState<any>([])
  const [wordInfo, setWordInfo] = useState<any>()
  const [isShowModal, setIsShowModal] = useState(false)
  const audioRef = useRef<any>()

  useEffect(() => {
    getSpeechCheck()
    getWordInfo()
  }, [])

  useEffect(() => {
    if (speechCheckDataBest) {
      setSpeechCheckData(speechCheckDataBest)
    }
  }, [isShowModal])

  useEffect(() => {
    if (speechCheckDataList) {
      const maxScoreItem = speechCheckDataList.reduce(
        (max: any, item: any) =>
          item?.total_score > max?.total_score ? item : max,
        speechCheckDataList[0],
      )
      setSpeechCheckDataBest(maxScoreItem)
    }
  }, [speechCheckDataList])

  const getSpeechCheck = async () => {
    if (!audioFileUser) return
    try {
      const formData = new FormData()
      formData.append('audio-file', audioFileUser)
      formData.append('text-refs', msg?.content)
      const res = await learnRequest.getSpeechCheck(formData)
      setSpeechCheckData(res?.data?.data)
      setSpeechCheckDataList([res?.data?.data])
    } catch (error) {}
  }

  const getColorByScore = (score: any) => {
    if (score >= 75) return '#45BB66'
    if (score >= 60) return '#FFCD00'
    if (score >= 0) return '#E55856'
  }

  const handleCloseModal = () => {
    setIsShowModal(false)
  }

  const handleStartRecording = () => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
  }

  const handleRecordingComplete = async (blob: any) => {
    let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
    const formData = new FormData()
    formData.append('audio-file', file)
    formData.append('text-refs', msg?.content)
    const res = await learnRequest.getSpeechCheck(formData)
    setSpeechCheckData(res?.data?.data)
    setSpeechCheckDataList((pre: any) => [...pre, res?.data?.data])
  }

  const getWordInfo = async () => {
    try {
      const params = {text: msg?.content}
      const res = await appRequest.getWordInfo(params)
      setWordInfo(res.data.data)
    } catch (error) {}
  }

  const handlePlayAudio = (url: any) => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
    audioRef.current = new Audio(url)
    audioRef.current.play()
  }

  const compareText = (data: any) => {
    let text = ''
    data?.result?.forEach((word: any) => {
      word.letters.forEach((char: any) => {
        text += char.letter
      })
    })
    return !!text
  }

  return (
    <>
      <HStack justifyContent={'flex-end'} spacing={4} className="user-message">
        <Box bg={'#EBF5FF'} p={'24px'} borderRadius={'24px'} maxWidth={'80%'}>
          <Text color={'#0054A3'} fontSize={'16px'}>
            {msg?.content}
          </Text>
          {speechCheckData && (
            <Flex
              cursor={'pointer'}
              justifyContent={'flex-end'}
              mt={2}
              alignItems={'center'}
              onClick={() => setIsShowModal(true)}>
              <Tooltip label={'Điểm phát âm'}>
                <Flex gap={1} alignItems={'center'}>
                  <Icon
                    as={MicIcon}
                    w={4}
                    h={4}
                    sx={{
                      path: {
                        fill: getColorByScore(
                          speechCheckData?.total_score * 100,
                        ),
                      },
                    }}
                  />
                  <Text
                    color={getColorByScore(speechCheckData?.total_score * 100)}>
                    {Math.floor(speechCheckData?.total_score * 100) || 0}
                  </Text>
                </Flex>
              </Tooltip>
            </Flex>
          )}
        </Box>
      </HStack>
      <Modal
        title={null}
        centered={true}
        footer={null}
        open={isShowModal}
        onCancel={handleCloseModal}>
        <Flex gap={'16px'}>
          <Image
            src={Volume}
            cursor={'pointer'}
            w={'40px'}
            onClick={() => handlePlayAudio(wordInfo?.audio)}
          />
          <Box>
            <Text fontSize={'20px'} fontWeight={600}>
              {compareText(speechCheckData) ? (
                speechCheckData?.result.map((word: any, index: any) => (
                  <Text key={index} as={'span'}>
                    {word.letters.map((char: any, index: any) => (
                      <Text
                        key={index}
                        as={'span'}
                        color={getColorByScore(char.score * 100)}>
                        {char.letter}
                      </Text>
                    ))}{' '}
                  </Text>
                ))
              ) : (
                <Text as={'span'} color={'red'}>
                  {`${wordInfo?.text}` || ''}
                </Text>
              )}
            </Text>
            <Text fontSize={'16px'}>{wordInfo?.ipa}</Text>
          </Box>
        </Flex>
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          gap={'16px'}
          mt={'16px'}>
          <CircularProgress
            value={Math.floor(speechCheckData?.total_score * 100) || 0}
            color={getColorByScore(speechCheckData?.total_score * 100)}
            size={'100'}
            thickness="4px">
            <CircularProgressLabel
              fontSize={'48px'}
              fontWeight={600}
              color={getColorByScore(speechCheckData?.total_score * 100)}>
              {speechCheckData
                ? Math.floor(speechCheckData?.total_score * 100)
                : 0 || '--'}
            </CircularProgressLabel>
          </CircularProgress>
          <Text fontSize={'16px'} fontWeight={600} color={'#AAAAAA'}>
            {speechCheckDataList?.length >= 3
              ? 'Bạn hãy học tiếp nhé!'
              : 'Hãy thử phát âm lại nhé!'}
          </Text>
          <Flex gap={'28px'} alignItems={'center'}>
            <Tooltip label="Nghe lại phát âm của bạn">
              <Center
                w={'40px'}
                h={'40px'}
                bg={'#eaf6fe'}
                borderRadius={'100%'}
                cursor={'pointer'}
                onClick={() => handlePlayAudio(speechCheckData?.audio_url)}>
                <Image
                  w={'20px'}
                  h={'20px'}
                  opacity={0.7}
                  src={headphoneIcon}
                />
              </Center>
            </Tooltip>
            <GlobalMic3
              isDisabled={speechCheckDataList?.length >= 3}
              handleStartRecording={handleStartRecording}
              handleRecordingComplete={handleRecordingComplete}
            />
            <Box w={'40px'} />
          </Flex>
        </Flex>
      </Modal>
    </>
  )
}

export default UserMsg
